import React, { useEffect, useState } from 'react';
import './Approvisionnement.css';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

const API = window.location.hostname === 'localhost'
  ? 'http://localhost:5000/api'
  : 'https://myssa1.osc-fr1.scalingo.io/api';

// ★ RÉGLAGES TABLEAU — position et dimensions
const TABLE_CONFIG = {
  maxWidth:   '1800px',
  maxHeight:   '600px',
  marginTop:    '80px',
  marginLeft:  '-50px',
};

// ★ RÉGLAGES LARGEURS COLONNES — ajuste les valeurs px selon tes besoins
// Clés = noms bruts de la base (avant tout renommage)
const COLUMN_WIDTHS = {
  'Numero de commande':       '140px',
  'Numero de ligne':           '90px',
  'Client':                   '140px',
  'Item':                     '160px',
  'Description':              '250px',
  'Date de commande':         '120px',
  'Date de livraison prevue': '140px',
  'Quantite commandee':        '120px',
  'Quantité commandée':        '120px',
  'Quantite livree':           '110px',
  'Quantité livrée':           '110px',
  'RAL':                        '70px',
  'Statut paiement':           '130px',
  'Horizon':                    '90px',
  'Fournisseur':               '160px',
  'Approvisionneur':           '150px',
  'Statut':                    '100px',
};
// Toute colonne absente du mapping reçoit cette largeur par défaut
const DEFAULT_WIDTH = '120px';

// Largeur totale = somme des colonnes (force le navigateur à respecter le layout fixe)
const calcTotalWidth = (cols) =>
  cols.reduce((s, c) => s + parseInt(COLUMN_WIDTHS[c] || DEFAULT_WIDTH, 10), 0);

const Commandeclient = () => {
  const [commandes, setCommandes]        = useState([]);
  const [colonnesAAfficher, setColonnes] = useState([]);
  const [filtres, setFiltres] = useState({ commandeID: '', item: '', client: '', dateLivraison: '' });

  useEffect(() => {
    document.title = 'MYSSA – Cmde Client';
  }, []);

  useEffect(() => {
    fetch(`${API}/base_de_donnee_cmde_client`)
      .then(r => r.json())
      .then(data => {
        if (data.length > 0) {
          const formatted = data.map(row => {
            const r = { ...row };
            ['Date de commande', 'Date de livraison prevue'].forEach(col => {
              if (r[col]) {
                const s = String(r[col]).split('T')[0].split('-');
                if (s.length === 3) r[col] = `${s[2]}/${s[1]}/${s[0]}`;
              }
            });
            return r;
          });
          setCommandes(formatted);
          setColonnes(Object.keys(data[0]).filter(c => c !== 'ID' && c !== 'Client_id'));
        }
      })
      .catch(err => console.error(err));
  }, []);

  const handleReset = () => setFiltres({ commandeID: '', item: '', client: '', dateLivraison: '' });

  const filtered = commandes.filter(cmd =>
    cmd['Numero de commande']?.toString().toLowerCase().includes(filtres.commandeID) &&
    cmd['Item']?.toLowerCase().includes(filtres.item) &&
    cmd['Client']?.toLowerCase().includes(filtres.client) &&
    cmd['Date de livraison prevue']?.toLowerCase().includes(filtres.dateLivraison)
  );

  const exportToExcel = () => {
    const ws  = XLSX.utils.json_to_sheet(filtered.map(r => ({ ...r })));
    const wb  = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Commandes clients');
    const buf = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    saveAs(new Blob([buf], { type: 'application/octet-stream' }), `commandes_clients_${new Date().toISOString().slice(0,10)}.xlsx`);
  };

  const inputStyle = {
    fontFamily: "'IBM Plex Sans', sans-serif",
    fontSize: '12px',
    padding: '6px 10px',
    border: '1px solid #e2d9cc',
    borderRadius: '6px',
    outline: 'none',
    background: '#fdfcfa',
    color: '#1e293b',
    width: '160px',
    height: '34px',
    boxSizing: 'border-box',
  };

  const btnStyle = {
    fontFamily: "'IBM Plex Mono', monospace",
    fontSize: '11px',
    letterSpacing: '0.07em',
    textTransform: 'uppercase',
    border: '1px solid #d4c9b8',
    borderRadius: '6px',
    background: 'linear-gradient(180deg, #04202d, #38bdf8)',
    color: 'white',
    cursor: 'pointer',
    width: '160px',
    height: '34px',
    boxSizing: 'border-box',
    padding: '0',
    flexShrink: 0,
  };

  const btnExportStyle = {
    ...btnStyle,
    background: '#ffffff',
    color: '#04202d',
    border: '1px solid #d4c9b8',
  };

  const totalWidth = calcTotalWidth(colonnesAAfficher);

  return (
    <div style={{ fontFamily: "'IBM Plex Sans', sans-serif" }}>

      {/* Bandeau titre */}
      <div style={{ position: 'absolute', top: '25px', left: '160px', display: 'flex', alignItems: 'center', gap: '10px' }}>
        <div style={{ width: '3px', height: '18px', background: 'linear-gradient(180deg, #04202d, #38bdf8)', borderRadius: '2px' }} />
        <span style={{ fontFamily: "'IBM Plex Mono', monospace", fontSize: '20px', fontWeight: '200', letterSpacing: '0.12em', textTransform: 'uppercase', color: '#04202d' }}>
          Commandes clients
        </span>
      </div>

      {/* Filtres */}
      <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap', marginTop: '80px', marginLeft: '-20px', marginBottom: '12px' }}>
        {[
          { name: 'commandeID',    placeholder: 'N° commande…' },
          { name: 'item',          placeholder: 'Item…' },
          { name: 'client',        placeholder: 'Client…' },
          { name: 'dateLivraison', placeholder: 'Date livraison…' },
        ].map(({ name, placeholder }) => (
          <input key={name} style={inputStyle} placeholder={placeholder}
            value={filtres[name]}
            onChange={e => setFiltres({ ...filtres, [name]: e.target.value.toLowerCase() })} />
        ))}
        <button style={btnStyle} onClick={handleReset}>Réinitialiser</button>
        <button style={btnExportStyle} onClick={exportToExcel}>Export Excel</button>
      </div>

      {/* Tableau */}
      <div
        className="table-container1"
        style={{
          marginLeft: TABLE_CONFIG.marginLeft,
          maxWidth:   TABLE_CONFIG.maxWidth,
          maxHeight:  TABLE_CONFIG.maxHeight,
          marginTop:  TABLE_CONFIG.marginTop,
        }}
      >
        {/*
          tableLayout: 'fixed' + largeur totale explicite = colonnes figées.
          width sur <col> utilise l'attribut HTML (plus fiable que style avec fixed layout).
        */}
        <table style={{ tableLayout: 'fixed', width: `${totalWidth}px` }}>

          {/* ★ Largeurs colonnes — modifie COLUMN_WIDTHS en haut du fichier */}
          <colgroup>
            {colonnesAAfficher.map(c => (
              <col key={c} width={COLUMN_WIDTHS[c] || DEFAULT_WIDTH} />
            ))}
          </colgroup>

          <thead>
            <tr>{colonnesAAfficher.map(c => <th key={c}>{c}</th>)}</tr>
          </thead>
          <tbody>
            {filtered.map((cmd, i) => (
              <tr key={i}>
                {colonnesAAfficher.map((col, j) => <td key={j}>{cmd[col]}</td>)}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Commandeclient;